import React, { useState, useEffect } from "react";
import { MdClose } from "react-icons/md";
import { FaPlus, FaCheck, FaRegCheckSquare, FaRegPlusSquare } from "react-icons/fa";
import { CircularProgress } from "@mui/material";
import tw from "tailwind-styled-components";
import { ActionSection, ModalHeader, ModalTitle, ScrollableContent, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";

const LinkUnlinkProps = ({ linkPropertyMutate, selectedData, setShowLinkUnlinkModel, properties, linkPropertyLoading }) => {
    //const [linkedProperties, setLinkedProperties] = useState([]);
    const [isApiInProgress, setIsApiInProgress] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [linkedProperties, setLinkedProperties] = useState([]);
    const [initialLinkedIds, setInitialLinkedIds] = useState([]);
    const isAllSelected = linkedProperties.length > 0 && linkedProperties.every(prop => prop.isLinked);

    const filteredProperties = linkedProperties.filter((property) =>
        property.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    // useEffect(() => {
    //     if (!properties || !selectedData?.propertyList) return;

    //     const list = Array.isArray(selectedData.propertyList)
    //         ? selectedData.propertyList.map(p => p.id)
    //         : [selectedData.propertyList.id];   // single object → convert to array

    //     setLinkedProperties(
    //         properties.filter(prop => prop.name !== "All Properties")
    //             .map(prop => ({
    //                 ...prop,
    //                 isLinked: list.includes(prop.id),
    //             }))
    //     );
    // }, [properties, selectedData]);

    useEffect(() => {
        if (!properties || !selectedData?.propertyList) return;

        const linkedIds = Array.isArray(selectedData.propertyList)
            ? selectedData.propertyList.map(p => p.id)
            : [selectedData.propertyList.id];

        setInitialLinkedIds(linkedIds);

        setLinkedProperties(
            properties
                .filter(prop => prop.name !== "All Properties")
                .map(prop => ({
                    ...prop,
                    isLinked: linkedIds.includes(prop.id),
                }))
        );
    }, [properties, selectedData]);

    const handleToggle = (propId) => {
        setLinkedProperties(prev =>
            prev.map(prop =>
                prop.id === propId
                    ? { ...prop, isLinked: !prop.isLinked }
                    : prop
            )
        );
    };

    const handleToggleAll = () => {
        setLinkedProperties(prev =>
            prev.map(prop => ({
                ...prop,
                isLinked: !isAllSelected,
            }))
        );
    };

    const handleSubmit = () => {
        const currentLinkedIds = linkedProperties
            .filter(prop => prop.isLinked)
            .map(prop => prop.id);

        const linkedProps = currentLinkedIds.filter(
            id => !initialLinkedIds.includes(id)
        );

        const unlinkedProps = initialLinkedIds.filter(
            id => !currentLinkedIds.includes(id)
        );

        linkPropertyMutate({
            extraChargeId: selectedData.id,
            linkedProps,
            unlinkedProps,
        });
    };

    const handleToggleOld = (propId, isLinked) => {
        if (isApiInProgress) return;

        setIsApiInProgress(true);
        setLinkedProperties((prev) =>
            prev.map((prop) =>
                prop.id === propId ? { ...prop, isLoading: true } : prop
            )
        );

        linkPropertyMutate(
            {
                extraChargeId: selectedData?.id,
                toggleValue: isLinked ? 0 : 1,
                propId: propId,
            },
            {
                onSuccess: () => {
                    setLinkedProperties((prev) =>
                        prev.map((prop) =>
                            prop.id === propId
                                ? { ...prop, isLinked: !isLinked, isLoading: false }
                                : prop
                        )
                    );
                    setIsApiInProgress(false);
                },
                onError: () => {
                    setLinkedProperties((prev) =>
                        prev.map((prop) =>
                            prop.id === propId ? { ...prop, isLoading: false } : prop
                        )
                    );
                    setIsApiInProgress(false);
                },
            }
        );
    };

    return (
        <Container>
            <ModalHeader>
                <ModalTitle>Manage Linked Properties</ModalTitle>
                <button onClick={() => setShowLinkUnlinkModel(false)}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>
            <ScrollableContent className="max-h-screen overflow-y-auto px-6 py-4">
                <div className="pt-2 pb-2">
                    <input
                        type="text"
                        placeholder="Search property..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="w-full rounded-md border border-gray-300 px-3 py-3 text-sm outline-none focus:border-primary-color"
                    />
                </div>
                <div className="flex items-center justify-between py-4 border-b">
                    <span className="text-sm font-medium text-gray-700">
                        Select All Properties
                    </span>

                    <button onClick={handleToggleAll}>
                        {isAllSelected ? (
                            <FaRegCheckSquare
                                size={20}
                                className="text-primary-color"
                            />
                        ) : (
                            <FaRegPlusSquare
                                size={20}
                                className="text-gray-400"
                            />
                        )}
                    </button>
                </div>

                {filteredProperties.length === 0 ? (
                    <div className="py-10 text-center text-sm text-gray-400">
                        No properties found.
                    </div>
                ) : (

                    filteredProperties.map((prop) => (
                        <PropertyRow key={prop.id}>
                            <Label>{prop.name}</Label>
                            <button
                                onClick={() => handleToggle(prop.id)}
                            >
                                {prop.isLinked ? (
                                    <FaRegCheckSquare
                                        size={20}
                                        className="text-primary-color"
                                    />
                                ) : (
                                    <FaRegPlusSquare
                                        size={20}
                                        className="text-gray-400"
                                    />
                                )}
                            </button>
                        </PropertyRow>
                    ))
                )}

            </ScrollableContent>
            <ActionSection>
                <SideCancelBtn
                    type="button"
                    onClick={() => setShowLinkUnlinkModel(false)}
                >
                    Cancel
                </SideCancelBtn>

                <SubmitBtn
                    type="button"
                    onClick={handleSubmit}
                    disabled={linkPropertyLoading}
                >
                    {linkPropertyLoading ? "Saving..." : "Save"}
                </SubmitBtn>
            </ActionSection>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const PropertyRow = tw.div`flex items-center justify-between py-5 border-b`;
const Label = tw.span`text-gray-600`;

export default LinkUnlinkProps;
